import { render, staticRenderFns } from "./MasterDataLevelList.vue?vue&type=template&id=98653a5c&"
import script from "./MasterDataLevelList.vue?vue&type=script&lang=js&"
export * from "./MasterDataLevelList.vue?vue&type=script&lang=js&"
import style0 from "./MasterDataLevelList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports